import type * as React from "react";

import { Chip, type ChipProps, type ChipTone } from "./Chip";
import {
  CheckCircleIcon,
  CheckIcon,
  CrossCircleIcon,
  DotCircleIcon,
  QuestionCircleIcon,
} from "./Icons";

/**
 * brian's `OrderStatus` (models/order.py): consented → accepted, in_progress → active,
 * completed → done. Waived, cancelled and superseded leave the plan.
 */
export type OrderStatus =
  | "proposed"
  | "accepted"
  | "active"
  | "done"
  | "declined";

const statusChip: Record<
  OrderStatus,
  { tone: ChipTone; label: string; Icon: React.ComponentType }
> = {
  proposed: { tone: "attention", label: "Proposed", Icon: QuestionCircleIcon },
  accepted: { tone: "brian", label: "Accepted", Icon: CheckCircleIcon },
  active: { tone: "brian", label: "Active", Icon: DotCircleIcon },
  done: { tone: "recorded", label: "Done", Icon: CheckIcon },
  declined: { tone: "declined", label: "Declined", Icon: CrossCircleIcon },
};

export interface StatusChipProps extends Omit<
  ChipProps,
  "tone" | "icon" | "children"
> {
  status: OrderStatus;
}

export function StatusChip({ status, ...rest }: StatusChipProps) {
  const { tone, label, Icon } = statusChip[status];
  return (
    <Chip tone={tone} icon={<Icon />} {...rest}>
      {label}
    </Chip>
  );
}
